import React, { useEffect, useState } from "react";

import { CheckoutEvents } from "core-web/libs/Events/constants";
import Events from "core-web/libs/Events";
import PropTypes from "prop-types";
import getCheckout from "core-web/state/models/Basket/dispatches/getCheckout";
import getMemberPromotions from "core-web/state/models/User/dispatches/getMemberPromotions";
import getQueryParams from "core-web/utils/getQueryParams";
import isEmpty from "core-web/state/models/Basket/utils/isEmpty";
import populateBasket from "core-web/state/models/Basket/dispatches/populateBasket";
import removeBasket from "core-web/state/models/Basket/dispatches/removeBasket";
import setBasketId from "core-web/state/models/Basket/dispatches/setBasketId";
import setBasketIdCookie from "core-web/state/models/Basket/utils/setBasketIdCookie";
import tracking from "core-web/components/Tracking";
import updateBasket from "core-web/state/models/Basket/dispatches/updateBasket";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const CheckoutContainer = ({ components }) => {
    const { isFetched } = useSelector(({ basket }) => basket);
    const items = useSelector(({ basket }) => basket.items);
    const clientIpAddress = useSelector(({ application }) => application.ipAddress) || "";
    const { email } = useSelector(({ user }) => user);
    const [currentComponent, setCurrentComponent] = useState(!isFetched ? "loading" : isEmpty() ? "empty" : "checkout");
    const location = useLocation();

    const addTrackingInfo = async () => {
        try {
            const trackingId = tracking.getClientId();
            const sessionId = tracking.getSessionId();
            const fbp = tracking.getFacebookFbp();
            const fbc = tracking.getFacebookFbc();
            const clientUserAgent = tracking.getFacebookClientUserAgent() || "";

            if (trackingId) {
                const trackingInfo = {
                    infos: [
                        {
                            code: "meta_cid",
                            value: tracking.getConsentStatistic() ? trackingId : "",
                        },
                        {
                            code: "meta_session_id",
                            value: tracking.getConsentStatistic() ? sessionId : "",
                        },
                        {
                            code: "meta_fbp",
                            value: tracking.getConsentMarketing() ? fbp : "",
                        },
                        {
                            code: "meta_fbc",
                            value: tracking.getConsentMarketing() ? fbc : "",
                        },
                        {
                            code: "meta_client_ip_address",
                            value: tracking.getConsentMarketing() ? clientIpAddress : "",
                        },
                        {
                            code: "meta_client_user_agent",
                            value: tracking.getConsentMarketing() ? clientUserAgent : "",
                        },
                    ],
                };

                await updateBasket(trackingInfo, true);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handlePopulateBasket = async (partNos) => {
        try {
            if (!partNos) {
                return;
            }

            const partNosArray = partNos.split(",");

            return await populateBasket(partNosArray);
        } catch (e) {
            return { error: e };
        }
    };

    const initCheckout = async () => {
        const { abandonedCartBasketId, partNos } = getQueryParams(location) || {};
        let checkoutResponse;
        if (abandonedCartBasketId) {
            setBasketId(abandonedCartBasketId);
            setBasketIdCookie(abandonedCartBasketId);
            checkoutResponse = await getCheckout({ isInitialFetch: true, overriddenBasketId: abandonedCartBasketId });
        } else if (partNos) {
            checkoutResponse = await handlePopulateBasket(partNos);
        } else {
            checkoutResponse = await getCheckout({ isInitialFetch: true });
        }

        if (checkoutResponse.error === 404 || checkoutResponse.error === 400) {
            removeBasket();
            setCurrentComponent("empty");
        } else {
            Events.trigger(CheckoutEvents.VIEW,
                {
                    basketId: checkoutResponse.basket.id,
                    items: checkoutResponse.basket.items
                }
            );

            addTrackingInfo();
        }
    };

    useEffect(() => {
        initCheckout();
    }, []);

    useEffect(() => {
        if (!isFetched) {
            return;
        }

        setCurrentComponent(isEmpty() ? "empty" : "checkout");
    }, [items]);

    useEffect(() => {
        if (email) {
            getMemberPromotions(email);
        }
    }, [email]);

    const RenderComponent = components[currentComponent] || null;

    return RenderComponent ? <RenderComponent height="90vh" /> : null;
};

CheckoutContainer.propTypes = {
    components: PropTypes.shape({
        checkout: PropTypes.node,
        empty: PropTypes.node,
        loading: PropTypes.node,
    }).isRequired,
};

export default CheckoutContainer;
